module.exports = __webpack_public_path__ + "img/x4.7fd8d35c.png";